import { useTranslation } from 'react-i18next';
import { getAnnualLeaveUrl } from '@/constant/approval';
import type { ContentExtraProps } from '../../types';
import InfoTable from '@/components/Approval/@components/InfoTable';
import useAttendanceDetail from './useAttendanceDetail';
import {
  formatLeaveDuration,
  formatLeavePeriods,
  formatWorkingHoursPair,
} from './format';
import { AttendanceSlotRoot } from './styles';
import type { AnnualLeaveDetail } from './types';

/** 231 (신규)연차 신청 */
const AnnualLeaveSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const { cell } = useAttendanceDetail<AnnualLeaveDetail>(
    getAnnualLeaveUrl(data.documentId),
  );

  return (
    <AttendanceSlotRoot>
      <InfoTable
        title={t('신청자 정보')}
        rows={[
          {
            label: t('근무시간'),
            value: cell((d) => formatWorkingHoursPair(d.workingHours)),
          },
        ]}
      />
      <InfoTable
        title={t('신청 내용')}
        rows={[
          { label: t('구분'), value: t('연차') },
          {
            label: t('신청 기간'),
            value: cell((d) => formatLeavePeriods(d.period, d.workingHours)),
          },
          {
            label: t('사용 시간'),
            value: cell((d) => formatLeaveDuration(d.usedTime?.duration, t)),
            emphasis: true,
          },
        ]}
      />
    </AttendanceSlotRoot>
  );
};

export default AnnualLeaveSlot;
